import { clsx } from 'clsx';
import React from 'react';
import styles from '../../product-timeline.module.scss';
import { TimelineStepStatus } from '../../interfaces/timeline';
import { useTranslation } from 'react-i18next';

const LabelView: React.FC<{
  status: TimelineStepStatus;
}> = ({ status }) => {
  const { t } = useTranslation();
  switch (status) {
    case 'ongoing':
      return (
        <div
          data-cy="timeline-step-status-in-progress"
          className={clsx(
            styles['ordersSales__mainRight__steps__step__box--text--625'],
            styles['ordersSales__mainRight__steps__step__box--text--blue'],
          )}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.PRODUCT.STATUS.IN_PROGRESS')}
        </div>
      );
    case 'cancelled':
      return (
        <div
          data-cy="timeline-step-status-canceled"
          className={clsx(
            styles['ordersSales__mainRight__steps__step__box--text--625'],
            styles['ordersSales__mainRight__steps__step__box--text--red'],
          )}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.PRODUCT.STATUS.CANCELLED')}
        </div>
      );
    case 'pending':
      return (
        <div
          data-cy="timeline-step-status-pending"
          className={clsx(
            styles['ordersSales__mainRight__steps__step__box--text--625'],
            styles['ordersSales__mainRight__steps__step__box--text--orange'],
          )}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.PRODUCT.STATUS.PENDING')}
        </div>
      );
    case 'done':
    case 'upcoming':
    case 'none':
      return <></>;
  }
};

export default LabelView;
